import React from "react";
import { Box, Typography } from "@mui/material";
import WhatsAppLink from "../../components/WhatsAppLink/WhatsAppLink";
import { PageLayout } from "../../components/PageLayout/PageLayout";
import Seo from "../../components/Seo/Seo";
import { PAGE_SEO } from "../../seo/seoConstants";
import { LocationContainer } from "../shared/styledComponents";
import { gaEvent } from "../../analytics";

const GOOGLE_MAPS_URL =
  "https://www.google.com/maps/place/Entorno+Biai+SAS/@6.9614714,-75.4167016,15z/data=!4m2!3m1!1s0x0:0xea84e6a68cf01e9?sa=X&ved=1t:2428&ictx=111";

const LocationPage: React.FC = () => {
  return (
    <PageLayout>
      <Seo {...PAGE_SEO["/ubicacion"]} />
      <LocationContainer>
        <Box p={2}>
          <Typography>
            Estamos ubicados en <strong>Calle. 18 #20 - 71</strong>, Nuestro horario de atención es
            de Lunes a Sábado de <strong>9 a 7 pm.</strong>
          </Typography>
          <Typography>
            <a
              href={GOOGLE_MAPS_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => gaEvent("maps_click", { source: "location_page" })}
            >
              Ver en Google Maps
            </a>
          </Typography>
          <WhatsAppLink />
        </Box>
      </LocationContainer>
    </PageLayout>
  );
};

export default LocationPage;
